import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useCommonApi } from '../api';
import { PATHS } from '../paths';
import { BoxWithHeader, PageLayout } from './common';
import { Accident } from './types/accident';

interface AccidentCreationConfirmPageContentProps {
  id?: string;
  accident?: Accident;
  accidentTaken?: boolean;
}

const AccidentCreationConfirmPageContent = ({
  id,
  accident,
  accidentTaken
}: AccidentCreationConfirmPageContentProps) => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <BoxWithHeader title="Potvrzení založení nehody">
        <Stack alignItems="center" my={3}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: '100px' }} />
          <Typography variant="h4" fontWeight="bold" mt={2} textAlign="center">
            {id && accidentTaken ? `Nehoda č. ${accident?.contractNumber} byla založena` : 'Nehoda byla zaevidována'}
          </Typography>
          <Stack direction={{ xs: 'column', md: 'row' }} gap={3} mt={3}>
            {id && accidentTaken && (
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate(PATHS.ACCIDENTS(Number.parseInt(id)))}
                endIcon={<ChevronRightIcon />}
              >
                Detail nehody
              </Button>
            )}
            <Button variant="outlined" onClick={() => navigate(PATHS.HOME)} size="large" endIcon={<ChevronRightIcon />}>
              Zpět na domovskou obrazovku
            </Button>
          </Stack>
        </Stack>
      </BoxWithHeader>
    </PageLayout>
  );
};

export const AccidentCreationConfirmPage = () => {
  const { accidentId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const accidentTaken = searchParams.get('accidentTaken') === 'true';

  const { data: accidentData } = useQuery(useCommonApi().getAccident(accidentId as string));

  return <AccidentCreationConfirmPageContent id={accidentId} accident={accidentData} accidentTaken={accidentTaken} />;
};
